import { render, staticRenderFns } from "./FileDeletionConfirmationDialog.vue?vue&type=template&id=f3713e7e"
import script from "./FileDeletionConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./FileDeletionConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports